<template>
  <div>
    <div class="desc">该项目完全开源，<a href="https://github.com/Jinnrry/ToolsBox">Github地址</a>
    	新功能建议可以Issues中提出!
    </div>
    <div class="desc">


    </div>

  </div>
</template>

<script>
export default {
  name: "About"
}
</script>

<style scoped>
.desc {
  text-align: center;
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue